import { LocalUser } from './user.graphql'
import { CurrentBusiness } from './business.graphql'
import MutationHelper from '@/graphql/local/mutation-helper'

export default {
  Mutation: {
    updateCurrentBusiness(_, { business }, { cache }) {
      const data = MutationHelper.updateCache(cache, { query: CurrentBusiness }, x => (x.localBusiness.id = business.id))
      return data.localBusiness
    },
    updateLocalUser(_, { user }, { cache }) {
      const data = MutationHelper.updateCache(cache, { query: LocalUser }, x => {
        if (user.isConnected !== null && user.isConnected !== undefined) {
          x.user.isConnected = user.isConnected
        }

        if (user.accessToken !== null && user.accessToken !== undefined) {
          x.user.accessToken = user.accessToken
        }

        if (user.refreshToken !== null && user.refreshToken !== undefined) {
          x.user.refreshToken = user.refreshToken
        }
      })

      return data.user
    }
  }
}
